import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {VendorGroupsProductsService} from '../../../services/vendor-groups-products/vendor-groups-products.service';
import {FieldType, MemberAddeditComponent, MemberAddeditDialogModel} from '../member-addedit/member-addedit.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UiAlertService} from '../../../services/ui-alert/ui-alert.service';
import {VendorProductsService} from '../../../services/vendorproducts/vendorproducts.service';
import _ from 'lodash';
import {MatSort} from '@angular/material/sort';
import {fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-vendor-groups-products',
  templateUrl: './vendor-groups-products.component.html',
  styleUrls: ['./vendor-groups-products.component.scss']
})
export class VendorGroupsProductsComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('search') search: ElementRef | undefined;

  protected allColumnNames = ['createdAt', 'vendorProductName', 'metadata.shortName', 'metadata.tag', 'metadata', 'actionmenu'];
  protected items = new MatTableDataSource<any>();

  private addEditFields = [
    {name: 'vendorProductIds', label: 'Vendor Products', fieldType: FieldType.F_DROPDOWN, multiple: true, values: Array<any>(), required: true},
    {name: 'metadata', label: 'Configuration JSON', fieldType: FieldType.F_JSON, required: true},
  ];

  constructor(
      private vendorGroupsProductsService: VendorGroupsProductsService,
      private dialog: MatDialog,
      private snackBar: MatSnackBar,
      private uiAlertService: UiAlertService,
      private vendorProductsService: VendorProductsService,
      private router: Router,
      private activatedRoute: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      // @ts-ignore
      this.search.nativeElement.value = params.get('search') || '';
      this.reloadItems();
    });
    fromEvent(this.search?.nativeElement, 'keyup').pipe(
        filter(Boolean),
        debounceTime(300),
        distinctUntilChanged(),
        tap((): void => {
          this.reloadItems();
          this.router.navigate([] , {
            relativeTo: this.activatedRoute,
            queryParams: {search: this.search?.nativeElement.value ?? ''},
            queryParamsHandling: 'merge'
          });
        })).subscribe();
  }

  private reloadItems(): void {
    this.vendorGroupsProductsService.getAllVendorGroupProducts(10000, 0, this.search?.nativeElement.value ?? '').then(products => {
      this.items.data = products;
      this.items.sort = this.sort;
    });
    this.vendorProductsService.getAllVendorProducts().then(vendors => {
      this.addEditFields[0].values = _.sortBy(vendors.map((vendor: { vendorName?: any; productName?: any; id: any; }) => `${vendor.vendorName.toLowerCase()} ${vendor.productName.toLowerCase()}:${vendor.id}`));
    });
  }

  addItem(): void {
    const dialogRef = this.dialog.open(MemberAddeditComponent, {
      data: new MemberAddeditDialogModel(null, this.addEditFields, 'Group Product')
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.vendorGroupsProductsService.createVendorGroupProduct(dialogResult.vendorProductIds, dialogResult.metadata).then(() => {
          this.reloadItems();
          this.snackBar.open('New group product created');
        });
      }
    });
  }

  editItem(item: any): void {
    const dialogRef = this.dialog.open(MemberAddeditComponent, {
      data: new MemberAddeditDialogModel(item, this.addEditFields, 'Group Product')
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.vendorGroupsProductsService.modifyVendorGroupProduct(item.id, dialogResult).then(() => {
          this.reloadItems();
          this.snackBar.open('Group product updated');
        });
      }
    });
  }

  duplicateItem(item: any): void {
    this.vendorGroupsProductsService.createVendorGroupProduct(item.vendorProductIds, item.metadata).then(() => {
      this.reloadItems();
      this.snackBar.open('Duplicate group product created');
    });
  }

  removeItem(item: any): void {
    this.uiAlertService.presentAlertConfirm('Do you really want to remove this group product?').then(ok => {
      this.vendorGroupsProductsService.deleteVendorGroupProduct(item.id).then(() => {
        this.reloadItems();
        this.snackBar.open('Group product removed');
      });
    });
  }

  truncateJSONString(str: string, maxLength: number): string {
    str = JSON.stringify(str);
    return str.length <= maxLength ? str : str.slice(0, maxLength - 3) + '...';
  }

}
